import $ from 'jquery'
import NProgress from 'nprogress'
import store from '@/store'
export default {
    name: 'registre-nfs',
    components: {},
    props: [],
    data() {
        return {
            analyse: "NFS",
            listeRegistre: [],
            loading: false,
        }
    },
    async beforeRouteEnter(to, from, next) {


        NProgress.start()
        store.commit('SET_REGISTRE',null)

        await store.dispatch("getRegistre", "NFS").then(
            () => {

                /*  Vue.nextTick(function(){
                     app.listeRegistre = app.registre;
                 }) */
                next(vm => {
                    vm.$root.listeRegistre  = vm.$root.registre
                })
                NProgress.done()
            }
        )


    },
    computed: {
        registre() {
            return this.$store.getters["registre"]
        },
    },
    created() {
        
        this.listeRegistre = this.registre
        console.log('liste ', this.listeRegistre)
    },
    mounted() {
        setTimeout(() => {
            $('.shw').fadeIn()
        }, 500);
    },
    methods: {
        saveResults: function() {
            this.loading = true
            this.$store.dispatch("saveDemandesResult", { data: this.listeRegistre, analyse: this.analyse }).then(
                () => {
                    this.loading = false
                    this.successMessage()
                }
            )
        },
        successMessage: function() {
            this.$toasted.show('Les résultats ont été enregistrés', {
                duration: 2000,
                action: [{
                    text: 'Fermer',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'
            })
        },
    }
}